import TasksKanban from './TasksProjectKanban'

export default TasksKanban
